// i18n
import './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import { MotionLazyContainer } from './components/animate';
import { SettingsProvider } from './components/settings';

// ----------------------------------------------------------------------

export default function App() {
  const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST!,
  };
  return (
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY!} options={options}>
      <HelmetProvider>
        <SettingsProvider>
          <BrowserRouter>
            <MotionLazyContainer>
              <ThemeProvider>
                <ThemeLocalization>
                  <Router />
                </ThemeLocalization>
              </ThemeProvider>
            </MotionLazyContainer>
          </BrowserRouter>
        </SettingsProvider>
      </HelmetProvider>
    </PostHogProvider>
  );
}
